import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Product, ProductService, GungFlowService, AuthService, SelectedCustomerService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class TyloProductService extends ProductService {
  protected override http = inject(HttpClient);
  protected override gungFlowService = inject(GungFlowService);
  protected override authService = inject(AuthService);
  protected override selectedCustomerService = inject(SelectedCustomerService);
  private translateService = inject(TranslateService);

  protected productMap(product: Product): Product {
    const mappedProduct = super.productMap(product);
    mappedProduct.name = this.getProductName(product);
    return mappedProduct;
  }

  private getProductName(product: Product): string {
    const lang = this.translateService.currentLang || 'se';

    let name = '';
    if (product.extra.i18n && product.extra.i18n[lang]) {
      name = product.extra.i18n[lang].itemName || '';
    }

    return name || product.name;
  }
}
